
import classes from "./PaddingContainer.module.css";
import { useSelector } from "react-redux";
import SubscriptionExpiredBanner from "../SubscriptionExpiredBanner";
const PaddingContainer = ({ children, className }) => {
  const { screenBg } = useSelector((state) => state?.screenBgReducer);
  console.log("Abc", screenBg)
  return (
    <div className={[classes.wrapper, className].join(" ")} style={{ background: screenBg }}>
      {/* <SubscriptionExpiredBanner /> */}
      {children}</div>
  );
};

export default PaddingContainer;
